import { track } from "@core/tracking";
var errorShown = function(data) {
    track("received error", data);
};
export var NotificationTracking = {
    errorShown: errorShown
};

//# sourceMappingURL=NotificationTracking.js.map